module.exports = __webpack_public_path__ + "ipetbooking-landing/img/add-on.7f6fa3cd.svg";